import $ from "jquery";

// When the user scrolls down 50px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    $('#backToTop').addClass('is-stuck');
  } else {
    $('#backToTop').removeClass('is-stuck');
  }
}

var $backToTopBtn = $('#backToTop');
//will scroll the user back to the top using the smooth animation
if ($backToTopBtn.length) {
    $backToTopBtn.on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 250);
    });
}

//function to recalculate position of mobile sticky nav on device orientation change
function reCalcStickyNav() {
    if ($('.sticky-menu-general').length) {
        $(window).on('changed.zf.mediaquery', function () {
            if (Foundation.MediaQuery.is('small only') && $('#general-mobile-sticky').length) {
                //Called on every scroll event and on _init fires functions based on booleans and cached values
                $('#general-mobile-sticky').foundation('_calc', true, scroll);
            }
        });
    }
}

reCalcStickyNav();


// mobile dropdown sticky submenu in community-subheader & blog-landing
// close menu on .dropdown-menu-placeholder click
$('.dropdown-menu-item > a').click(function () {
    $('#mobile-dropdown-menu').foundation('close');
});
